import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE, TOTAL_VALUE } from '../data/offer';
import { useCountdown } from '../hooks/useCountdown';
import { trackPixelEvent } from '../utils/metaPixel';
export function StickyMobileCta() {
  const {
    minutes,
    seconds
  } = useCountdown(14 * 60 + 59);
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-4 pb-3 pt-2.5 backdrop-blur sm:hidden" data-id="element-246" data-mp="vq1v7k7helus">
      <div className="flex items-center gap-3" data-id="element-247" data-mp="3u6xdu5ihyrg6">
        <div className="min-w-0" data-id="element-248" data-mp="31xmsqxizuoe">
          <p className="flex items-baseline gap-1.5" data-id="element-249" data-mp="338siwaj7ci5">
            <span className="font-display text-2xl font-semibold leading-none text-ink" data-id="element-250" data-mp="81a651p6ujm8">
              ${PRICE}
            </span>
            <span className="text-xs text-muted line-through" data-id="element-251" data-mp="ctadhf7l8esu">
              ${TOTAL_VALUE}
            </span>
          </p>
          <p className="mt-0.5 text-[10px] font-bold uppercase tracking-[0.1em] text-terracotta" data-id="element-252" data-mp="3bgem195kuujb">
            Ends in {minutes}:{seconds}
          </p>
        </div>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('InitiateCheckout', {
        content_name: 'The Perfect Dog Method — Complete bundle',
        value: PRICE,
        currency: 'USD'
      })} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-terracotta px-4 py-3.5 text-center text-[13px] font-extrabold uppercase leading-tight tracking-[0.04em] text-white transition-colors duration-150 ease-out active:bg-terracotta-dark" data-id="element-253" data-mp="29h5t9y6yx0bl">
          Get it for $25
          <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-254" data-mp="1gvmdr4fc1eqt" />
        </a>
      </div>
    </div>;
}